import { Star } from "lucide-react"
import { cn } from "@/lib/utils"
import { useState } from "react"

type Props = {
  value: number | undefined
  onChange: (value: number) => void
  className?: string
}

export const StarInput = ({ value = 0, onChange, className }: Props) => {
    const [hoverValue, setHoverValue] = useState<number | null>(null)

    const handleMouseMove = (index: number) => {
        setHoverValue(index)
    }

    const handleMouseLeave = () => {
      setHoverValue(null)
    }

    const handleClick = (index: number) => {
        // If clicking the same star, toggle it off (set to 0)
        onChange(value === index ? 0 : index)
    }

    const displayValue = hoverValue !== null ? hoverValue : value || 0

    return (
      <div
        className={cn("flex items-center gap-1", className)}
        onMouseLeave={handleMouseLeave}
        role="radiogroup"
        aria-label="Rating"
      >
        {Array.from({ length: 5 }).map((_, index) => {
          const starValue = index + 1
          const isFilled = starValue <= displayValue

          return (
            <Star
              key={index}
              size={16}
              className={cn(
                "cursor-pointer transition-all",
                isFilled ? "fill-yellow-400 text-yellow-400" : "fill-none text-muted-foreground",
              )}
              onMouseMove={() => handleMouseMove(starValue)}
              onClick={() => handleClick(starValue)}
              role="radio"
              aria-checked={value === starValue}
              aria-label={`${starValue} star${starValue === 1 ? "" : "s"}`}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault()
                  handleClick(starValue)
                }
              }}
            />
          )
        })}
      </div>
    )
}
